"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_styles_1 = require("./Card.styles");
var CarvanaCircleIcon_1 = __importDefault(require("./icons/CarvanaCircleIcon"));
var formatAndDropDecimal_1 = __importDefault(require("../../../utils/formatAndDropDecimal"));
var Tag_1 = __importDefault(require("../../Tags/Tag"));
var TileDataContext_1 = require("../../TileDataContext");
function GreatDeal() {
    var _a = (0, TileDataContext_1.useTileDataContext)(), total = _a.tileData.price.total, price = _a.financeInfo.price;
    if (!price.kbbValue)
        return null;
    var kbbValue = price.kbbValue;
    var kbbPriceDifference = kbbValue - total;
    var SavingsText = (react_1.default.createElement("div", { className: "t-body-s text-grey-5" },
        "This vehicle is priced",
        ' ',
        react_1.default.createElement("span", { className: "font-bold text-blue-4" },
            "$",
            (0, formatAndDropDecimal_1.default)(kbbPriceDifference)),
        ' ',
        "lower than the Kelley Blue Book\u00AE Typical Listing Price."));
    return (react_1.default.createElement(Card_styles_1.Card, { "data-qa": "great-deal-card" },
        react_1.default.createElement(Tag_1.default, { text: "Great Deal", bigTag: true, tag: "deal" }),
        react_1.default.createElement(Card_styles_1.MiddleWrapper, null,
            SavingsText,
            react_1.default.createElement(Card_styles_1.PillWrapper, null,
                react_1.default.createElement(Card_styles_1.KBBPill, null,
                    react_1.default.createElement("span", null, "Kelley Blue Book\u00AE"),
                    react_1.default.createElement("span", null,
                        "$",
                        (0, formatAndDropDecimal_1.default)(kbbValue))),
                react_1.default.createElement(Card_styles_1.CarvanaPill, null,
                    react_1.default.createElement("div", { className: "flex items-center" },
                        react_1.default.createElement("span", { className: "mr-8" }, "Carvana"),
                        react_1.default.createElement(CarvanaCircleIcon_1.default, null)),
                    react_1.default.createElement("span", null,
                        "$",
                        (0, formatAndDropDecimal_1.default)(total))))),
        react_1.default.createElement("div", { className: "text-grey-5 t-body-xs" }, "Savings amount based on the difference between Kelley Blue Book\u00AE Typical Listing Price and current Carvana listing price, not including tax, title, registration, or delivery costs. Savings amounts are updated daily.")));
}
exports.default = GreatDeal;
//# sourceMappingURL=GreatDealCard.js.map